// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-container[data-v-9ce0fc36]{width:100%;height:48px;line-height:48px;color:4A4747;text-align:center;font-size:20px}", ""]);
// Exports
module.exports = exports;
